import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './bodysection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import myImage from '../../../assets/images/handimage.png';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../registerflow/registerflow';
import justDeliveriesLogo from '../../../assets/images/JustDeliveries.png';
const contents = [
  {
    title: (
      <>
        100% <span>Security.</span> <br></br>Zero Compromise
      </>
    ),
    description:
      'Leaderly will never sell your data. All personal information and data will remain secure. They are locked tight in a secure server.',
  },
  {
    title: (
      <>
        Classified <span>Search</span> <br></br>Non-Disclosure Policy
      </>
    ),
    description:
      'We understand the sensitive nature of senior job openings in organizations. We guarantee complete discretion in your hiring process.',
  },
  {
    title: (
      <>
        Verified <span>Candidates</span> <br></br>Insightful Data
      </>
    ),
    description:
      'Shortlist exceptional candidates and select the right fit for your top management with our streamlined candidate search process.',
  },
  {
    title: (
      <>
        Say <span>Goodbye</span> <br></br>to Guesswork
      </>
    ),
    description: 'Accelerate your hiring process with smart tools. Reduce your turnaround time by 1/3rd.',
  },
];

const BodySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % contents.length);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const handleForwardClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % contents.length);
    setHovered(true);
    setTimeout(() => setHovered(false), 500);
  };

  const handleBackwardClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + contents.length) % contents.length);
    setHovered(true);
    setTimeout(() => setHovered(false), 500);
  };

  const handleLinkClick = (index, event) => {
    event.preventDefault();
    setCurrentIndex(index);
  };
  // const handleKnowMoreClick = () => {
  //   if (!sessionStorage.getItem("initialScrollPosition")) {
  //     sessionStorage.setItem("initialScrollPosition", window.scrollY);
  //   }
  //   sessionStorage.setItem("scrollPosition", window.scrollY);
  //   window.location.href = "/login";
  // };
  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

  const openRegisterPopup = () => {
    setRegisterPopupVisible(true);
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };

  return (
    <div className="body-section">
      <Container className="container-style">
        <Row>
          <Col md={6}>
            <div className="left-container">
              <div className="left-heading-container">
                <h2 className="left-heading">
                  Why <br /> partner with us?
                </h2>
              </div>

              <div className="d-flex justify-content-between mt-10 left-confidentiality-lorem-container">
                {contents.map((_, index) => (
                  <a
                    key={index}
                    href="#"
                    className={currentIndex === index ? 'active-link' : ''}
                    onClick={(e) => handleLinkClick(index, e)}
                  >
                    {index === 0 && 'Privacy'}
                    {index === 1 && 'Confidentiality'}
                    {index === 2 && 'Credibility'}
                    {index === 3 && 'Efficiency'}
                  </a>
                ))}
              </div>
              <div className="left-button-container">
                <button className="left-button" onClick={openRegisterPopup}>Start Free Trial</button>
              </div>
              <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />

              <div className="testimonial-box desktop-only">
                <p className="testimonial-text">
                  “The Leaderly hiring platform is of great value. The AI assessment interviews,
                  psychometric tests, and discreet reference checks enable hiring managers to get
                  deep insights into shortlisted candidates, helping us evaluate leadership fit
                  more confidently. The support provided to curate profiles makes the shortlisting
                  process far more efficient and meaningful. Truly a game-changer for leadership
                  hiring.”
                </p>

                <div className="testimonial-author">

                  <div className="author-left">
                    <div className="author-name">Mansi Mahansaria</div>
                    <div className="author-role">Founder & CEO</div>
                    <div className="author-company">Just Deliveries</div>
                  </div>

                  <div className="author-right">
                    {/* <div className="author-company">Just Deliveries</div> */}

                    <img
                      src={justDeliveriesLogo}
                      alt="Just Deliveries Logo"
                      className="author-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="right-container">
              <div className="right-content-image">
                <img src={myImage} alt="Image of hand shield" className="hand-image" />
              </div>
              <div className="right-info-container">
                <div className="right-icon-container">
                  <div className='right-icon'>

                    <FontAwesomeIcon
                      icon={faAngleLeft}
                      className="right-icon-backward"
                      onClick={handleBackwardClick}
                    /></div>
                  <div className='right-icon'>
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      className="right-icon-forward"
                      onClick={handleForwardClick}
                    />
                  </div>
                </div>
                <div className="right-info-text">
                  <p className="right-info-1">{contents[currentIndex].title}</p>
                  <p className="right-info-2">{contents[currentIndex].description}</p>
                </div>
              </div>
            </div>
          </Col>
          <div className="testimonial-box mobile-only">
            {/* <span className="testimonial-tag">Our Testimonial</span> */}

            <p className="testimonial-text">
              “The Leaderly hiring platform is of great value. The AI assessment interviews,
              psychometric tests, and discreet reference checks enable hiring managers to get
              deep insights into shortlisted candidates, helping us evaluate leadership fit
              more confidently. The support provided to curate profiles makes the shortlisting
              process far more efficient and meaningful. Truly a game-changer for leadership
              hiring.”
            </p>

            <div className="testimonial-author">
              <div className="author-details">
                <div className="author-name">Mansi Mahansaria</div>
                <div className="author-role">Founder & CEO</div>
                <div className="author-company">Just Deliveries</div>
              </div>
              <img
                src={justDeliveriesLogo}
                alt="Just Deliveries Logo"
                className="author-logo"
              />
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default BodySection;